var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1549_101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8285 9.17151L9.1715 14.8285M9.1715 9.17151L14.8285 14.8285",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1549_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/deactivate_icon.7579477c2f74c067e353091fd1a50cf8.svg";
export { ForwardRef as ReactComponent };